/* eslint-disable @typescript-eslint/no-var-requires */
const defaultTheme = require('tailwindcss/defaultTheme')

module.exports = {
  purge: ['./src/**/*.{js,jsx,ts,tsx,css}'],
  darkMode: false, // or 'media' or 'class'
  theme: {
    fontSize: {
      ...defaultTheme.fontSize,
      '2xs': '.625rem',
      xsm: '13px',
    },
    scale: {
      '37-5': '.375',
      ...defaultTheme.scale,
    },
    screens: {
      xs: '475px',
      ...defaultTheme.screens,
    },
    extend: {
      animation: {
        'rotate-center': 'rotate-center 1s linear infinite reverse both',
      },
      borderWidth: {
        1: '1px',
        3: '3px',
      },
      colors: {
        brand: {
          accent1: '#f9f871',
          accent2: '#21B0B8',
          accent3: '#80E49D',
          accent4: '#008fdc',
          accent5: '#73B06F',
          main: '#9489fa',
        },
        error: '#AD3939',
        folder: '#FFDC70',
      },
      keyframes: {
        'rotate-center': {
          '0%': {
            transform: 'rotate(0)',
          },
          to: {
            transform: 'rotate(360deg)',
          },
        },
      },
      height: {
        9.5: '2.375rem',
        18: '4.5rem',
        22: '90px',
        v65: '65vh',
      },
      width: {
        9.5: '2.375rem',
        22: '90px',
        62: '246px',
      },
      minWidth: {
        10: '2.5rem',
        24: '6rem',
      },
      padding: {
        2.25: '0.563rem',
      },
      boxShadow: {
        lg2: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 0px 15px -3px rgba(0, 0, 0, 0.1)',
      },
      flex: {
        80: '1 0 90%',
      },
    },
  },
  variants: {
    extend: {
      cursor: ['disabled'],
      opacity: ['disabled'],
    },
  },
  plugins: [
    require('@tailwindcss/line-clamp'),
    require('@tailwindcss/forms')({
      strategy: 'class',
    }),
  ],
}
